import type { TextProps } from '@ab-core/text';
import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import type { ScalableStyle } from '../../scalableStyles';
import { StyledInformationContainer } from './styled';

const textStyle: TextProps = {
    color: 'inherit',
    type: FontTypes.Subtitle
};

export type InformationContainerPropsStyleType = ScalableStyle<{
    isVisible: boolean;
}>;

export type InformationContainerType = {
    reach?: boolean;
};

export const InformationContainer: FC<InformationContainerType & InformationContainerPropsStyleType> = (props) => {
    const { reach, scalableStyle } = props;

    if (!scalableStyle?.isVisible) {
        return <></>;
    }

    if (!reach) {
        return <></>;
    }

    return (
        <StyledInformationContainer>
            <Text {...textStyle}>
                Informationspflicht nach Artikel 33 der REACH Verordnung: Dieses Produkt enthält ein oder mehrere
                Erzeugnisse, in welchen Stoffe der Kandidatenliste in einer Konzentration über 0,1 Massenprozent
                vorhanden sind.
            </Text>
        </StyledInformationContainer>
    );
};
